const RANKING_API_URL = import.meta.env.VITE_RANKING_API_URL;
const RANKING_API_KEY = import.meta.env.VITE_RANKING_API_KEY;

export const apiRankUpdate = async (
  payload: {
    gameId: string;
    userId: string;
    username: string;
    score: number;
  },
  token: string,
): Promise<any> => {
  try {
    const response = await fetch(`${RANKING_API_URL}/update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": RANKING_API_KEY,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiRankUpdate is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiRankUpdate successful:", result);
    return result;
  } catch (error) {
    console.error("apiRankUpdate Error:", error);
    throw error;
  }
};

export const apiRankMine = async (
  payload: {
    gameId: string;
    userId: string;
  },
  token: string,
): Promise<any> => {
  try {
    const response = await fetch(`${RANKING_API_URL}/mine`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": RANKING_API_KEY,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiRankUpdate is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiRankMine successful:", result);
    return result;
  } catch (error) {
    console.error("apiRankMine Error:", error);
    throw error;
  }
};

export const apiRankList = async (
  payload: {
    gameId: string;
    userId: string;
    seasonId?: string;
    page?: number;
    perPage?: number;
    friendIds?: string[];
  },
  token: string,
): Promise<any> => {
  try {
    // 1. 기본값 설정 (구조 분해 할당 시 기본값 지정)
    const {
      gameId,
      userId,
      seasonId = "all",
      page = 1,
      perPage = 10,
      friendIds = [],
    } = payload;

    // 2. 기본값이 적용된 새로운 객체 생성
    const requestBody = {
      gameId,
      userId,
      seasonId,
      page,
      perPage,
      friendIds,
    };

    const response = await fetch(`${RANKING_API_URL}/list`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": RANKING_API_KEY,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody), // 수정된 객체 전달
    });

    if (!response.ok) {
      console.error(response);
      throw new Error(
        `apiRankList is failed: ${response.statusText}(${response.status})`,
      );
    }

    const result = await response.json();
    console.log("apiRankList successful:", result);
    return result;
  } catch (error) {
    console.error("apiRankList Error:", error);
    throw error;
  }
};
